(ns frontend.view.components.timeline.entry.oppo-update
  (:require
   [frontend.view.components.timeline.entry.declaration :as te]
   [frontend.view.components.timeline.entry.default-item :as default]
   [frontend.view.components.timeline.entry.utils :as utils]
   [clojure.set :as set]
   [cljs.reader :as edn]
   [common.localization :as loc]
   [common.entity :as zap-entity]
   [frontend.utils :as main-utils]
   [frontend.state.current-session :as session]
   [frontend.routing :as routing]
   [common.schema.registry :as registry]))

(defn ratings
  [accounts f-val]
  (let [ratings-map (:set f-val)
        old-map (:unset f-val)
        r-set (-> ratings-map
                  edn/read-string
                  set)
        o-set (-> old-map
                  edn/read-string
                  set)
        ;;show only the updated part of the ratings-map value:
        changes-set (set/difference r-set o-set)]
    [:ul
     (doall (for [[r-key r-value :as _keyval] changes-set
                  :let [account (->> accounts
                                     (filter (fn [account] (= r-key (:db/id account))))
                                     first)]]
              ^{:key r-key}
              [:li
               [:span (zap-entity/display-string account)]
               " : "
               [:span (float (/ (Math/round (* 50 r-value)) 10))]]))]))

(defn person-body-generator
  [_person entry]
  (let [tenant-schema @session/tenant-schema
        changes (:audit/target-changes entry)]
    [:div
     (doall
      (for [[f-key f-val] changes]
        (when-not (some #{f-key} [:common/updated-by :common/updated-on :person/fullcontact-person])
          (let [f-set (main-utils/if-bigdec-or-bigint-then-string (:set f-val))]
            ^{:key (str "timeline-op-company-update" f-key)}
            [:div
             (case f-key
               :db/id nil
               (utils/arrow-message (let [fs (registry/get-field-schema tenant-schema
                                                                        f-key)]
                                      (loc/field-name f-key fs))
                                    (zap-entity/display-string f-set)))]))))]))

;; changes to :oppo/status-and-next-steps
;;  will be shown in dashboard timeline => title needs to show deal name
(defn title-generator
  [entry]
  (if (-> entry
          :audit/target-changes
          :oppo/status-and-next-steps
          nil?)
    (default/title-generator entry)
    (let [deal-name (->> entry
                         :audit/target
                         (get @session/entities)
                         :oppo/name)]
      (loc/tr :named-deal [deal-name]))))

(defmethod te/timeline-entry-view :op.oppo/update
  [{entry :entry accounts :accounts target-person :target-person}]
  (let [tenant-schema @session/tenant-schema
        body-generator
        (fn [entry]
          (let [changes (:audit/target-changes entry)]
            [:div
             (doall
              (for [[f-key f-val] changes]
                (when-not (some #{f-key}
                                [:common/updated-by :common/updated-on :person/fullcontact-person])
                  (let [f-set (main-utils/if-bigdec-or-bigint-then-string (:set f-val))]
                    ^{:key (str "timeline-op-oppo-update" f-key)}
                    [:div
                     (case f-key
                       :oppo/ratings (utils/arrow-message
                                      (let [fs (registry/get-field-schema tenant-schema
                                                                          f-key)]
                                        (loc/field-name f-key fs))
                                      (ratings accounts f-val))
                       :db/id nil
                       (utils/arrow-message
                        (let [fs (registry/get-field-schema tenant-schema f-key)]
                          (loc/field-name f-key fs))
                        (zap-entity/display-string f-set)))]))))]))]
    (if target-person
      ;;different appearance for person timeline
      [default/timeline-item-view entry
       (partial utils/person-timeline-title-generator target-person)
       (partial person-body-generator target-person)
       default/timestamp-generator]
      [default/timeline-item-view entry title-generator body-generator
       default/timestamp-generator])))

(defmethod te/timeline-entry-view :op.oppo/any-update
  [{entry :entry}]
  (let [tenant-schema @session/tenant-schema
        body-generator
        (fn [entry]
          (let [changes (:audit/target-changes entry)]
            [:div
             ;; note: 'changes' never contain other than {:db/id oppo-id :common/updated-on latest-timestamp},
             (doall (for [[f-key f-val] changes]
                      (cond
                        (not (some #{f-key}
                                   [:db/id :common/updated-by :common/updated-on
                                    :person/fullcontact-person]))
                        (let [f-set (main-utils/if-bigdec-or-bigint-then-string (:set f-val))]
                          ^{:key (str "timeline-op-oppo-update" f-key)}
                          [:div
                           (utils/arrow-message
                            (let [fs (registry/get-field-schema tenant-schema f-key)]
                              (loc/field-name f-key fs))
                            (zap-entity/display-string f-set))]))))]))]
    [default/timeline-item-view entry
     (fn [entry]
       (let [oppo-id (:audit/target entry)]
         [:div
          [:span (loc/tr :entity.type/oppo)]
          " "
          [:a
           {:href     "#"
            :on-click (fn [e]
                        (.preventDefault e)
                        (.stopPropagation e)
                        (routing/set-view! [:entity.type/oppo :id oppo-id]))}
           ""
           (->> (get @session/entities oppo-id)
                (:oppo/name)
           ) ""]
          " "
          [:span (loc/tr :updated)]]))
     body-generator default/timestamp-generator]))
